import React from "react";

interface Rectangle4CutCornersProps {
  a: string | number;
  b: string | number;
  c: string | number;
  arrowColor?: string;
  textColor?: string;
  foldType?: string;
  foldDirection?: 1 | 2; // 1 = Horizontal, 2 = Vertical
}

const Rectangle4CutCorners: React.FC<Rectangle4CutCornersProps> = ({
  a,
  b,
  c,
  arrowColor = "#000",
  textColor = "#000",
  foldType,
  foldDirection
}) => {
  return (
    <svg
      width="233"
      height="224"
      viewBox="-30 0 260 204"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Rectangle with 4 Cut Corners */}
      <path
        d="M47.2002 71.4473L80.4458 38.2017L144.532 38.2017L177.782 71.4475L177.782 135.534L144.532 168.784L80.4459 168.784L47.2002 135.534L47.2002 71.4473Z"
        stroke="#1E8F31"
        strokeWidth="3"
      />

      {/* Arrows */}
      <path
        d="M43.5 20.5L49.5 23.9641V17.0359L43.5 20.5ZM181 20.5L175 17.0359V23.9641L181 20.5ZM48.9 21.1H175.6V19.9H48.9V21.1Z"
        fill={arrowColor}
      />
      <path
        d="M22 34L18.2472 40.5H25.7528L22 34ZM22 172L25.7528 165.5H18.2472L22 172ZM21.35 39.85L21.35 166.15H22.65L22.65 39.85H21.35Z"
        fill={arrowColor}
      />
      <path
        d="M194 147L187.308 148.793L192.207 153.692L194 147ZM157 184L163.692 182.207L158.793 177.308L157 184ZM189.757 150.394L160.394 179.757L161.243 180.606L190.606 151.243L189.757 150.394Z"
        fill={arrowColor}
      />

      {/* Letters */}
      <text
        textAnchor="end"
        fontFamily="Roboto"
        fontSize="12"
        y="103.42856"
        x="17.73856"
        fill={textColor}
      >
        A: {a}
      </text>
      <text
        textAnchor="middle"
        fontFamily="Roboto"
        fontSize="12"
        y="15.80991"
        x="110.59524"
        fill={textColor}
      >
        B: {b}
      </text>
      <text
        fontFamily="Roboto"
        fontSize="12"
        y="178.19013"
        x="177.92824"
        fill={textColor}
      >
        C: {c}
      </text>

      {/* Bi Fold V */}
      {foldType === "Bi-Fold" && foldDirection === 2 && (
        <line
          x1="112.6"
          y1="42"
          x2="112.6"
          y2="165"
          stroke="#1E8F31"
          strokeWidth="1.2"
          strokeDasharray="6 6"
        />
      )}

      {/* Tri Fold V */}
      {foldType === "Tri-Fold" && foldDirection === 2 && (
        <>
          <path
            d="M87.6 42L87.6 165"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <path
            d="M136.6 42V165"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}

      {/* Quad Fold V */}
      {foldType === "Quad-Fold" && foldDirection === 2 && (
        <>
          <line
            x1="112.6"
            y1="42"
            x2="112.6"
            y2="165"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="81.6"
            y1="42"
            x2="81.6"
            y2="165"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="143.6"
            y1="42"
            x2="143.6"
            y2="165"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}

      {/* Five Fold V */}
      {foldType === "Five-Fold" && foldDirection === 2 && (
        <>
          {["75.4", "100.2", "125", "149.8"].map((x) => (
            <line
              key={x}
              x1={x}
              y1="42"
              x2={x}
              y2="165"
              stroke="#1E8F31"
              strokeWidth="1.2"
              strokeDasharray="6 6"
            />
          ))}
        </>
      )}

      {/* Six Fold V */}
      {foldType === "Six-Fold" && foldDirection === 2 && (
        <>
          {["71.2", "91.8", "112.4", "133", "153.6"].map((x) => (
            <line
              key={x}
              x1={x}
              y1="42"
              x2={x}
              y2="165"
              stroke="#1E8F31"
              strokeWidth="1.2"
              strokeDasharray="6 6"
            />
          ))}
        </>
      )}

      {/* Bi Fold H */}
      {foldType === "Bi-Fold" && foldDirection === 1 && (
        <line
          x1="51"
          y1="103.4"
          x2="174"
          y2="103.4"
          stroke="#1E8F31"
          strokeWidth="1.2"
          strokeDasharray="6 6"
        />
      )}

      {/* Tri Fold H */}
      {foldType === "Tri-Fold" && foldDirection === 1 && (
        <>
          <line
            x1="51"
            y1="79.4"
            x2="174"
            y2="79.4"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="51"
            y1="128.4"
            x2="174"
            y2="128.4"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}

      {/* Quad Fold H */}
      {foldType === "Quad-Fold" && foldDirection === 1 && (
        <>
          <line
            x1="51"
            y1="103.4"
            x2="174"
            y2="103.4"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="51"
            y1="72.4"
            x2="174"
            y2="72.4"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="51"
            y1="134.4"
            x2="174"
            y2="134.4"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}

      {/* Five Fold H */}
      {foldType === "Five-Fold" && foldDirection === 1 && (
        <>
          {["66.2", "91", "115.8", "140.6"].map((y) => (
            <line
              key={y}
              x1="51"
              y1={y}
              x2="174"
              y2={y}
              stroke="#1E8F31"
              strokeWidth="1.2"
              strokeDasharray="6 6"
            />
          ))}
        </>
      )}

      {/* Six Fold H */}
      {foldType === "Six-Fold" && foldDirection === 1 && (
        <>
          {["62.06", "82.7199", "103.38", "124.04", "144.7"].map((y) => (
            <line
              key={y}
              x1="51"
              y1={y}
              x2="174"
              y2={y}
              stroke="#1E8F31"
              strokeWidth="1.2"
              strokeDasharray="6 6"
            />
          ))}
        </>
      )}
    </svg>
  );
};

export default Rectangle4CutCorners;

